<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import ListEmpty from '../../../../app/components/list/ListEmpty.vue'

  import * as restfulService from '../../../services/restfulService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapGetters} from 'vuex'

  import {cloneDeep} from 'lodash'
  import {Chart} from 'highcharts-vue'

  export default {
    components: {ListHeader, ListEmpty, highcharts: Chart},
    mixins: [helpers],
    data () {
      return {
        isLoadingData: true,
        event: {
          id: 0,
          title: ''
        },
        list: [],
        registrations: [],
        papers: [],
        chartLineOptionsRegistrations: null,
        chartLineOptionsPapers: null,
        chartLineOptions: {
          chart: {type: 'line'},
          title: {text: ''},
          xAxis: {categories: []},
          yAxis: {title: {text: 'Total'}},
          plotOptions: {
            line: {
              dataLabels: {enabled: true},
              enableMouseTracking: false
            }
          },
          series: []
        }
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'roles']),
      userIsOnlySupportCommittee: function () {
        return this.roles && this.roles.length === 1 && this.roles[0] === 'Comissão de Apoio'
      },
      hasRootRole: function () {
        return this.roles && this.roles.some(item => item === 'Root')
      }
    },
    mounted () {
      const id = this.$route.params.id || null
      if (id) {
        restfulService.get('event', 'dashboard', id)
          .then(response => {
            this.event.id = response.event.id
            this.event.title = response.event.title
            this.list = response.event.events
            this.registrations = response.registrations
            this.papers = response.papers
            this.mountCharts()
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch((err) => {
            console.log(err)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
      } else {
        this.isLoadingData = false
        bus.$emit('hide-loader')
      }
    },
    methods: {
      userHaveAccess (coordinators) {
        return coordinators.some(coordinator => coordinator.user_id === this.currentUser.id) || this.hasRootRole
      },
      mountCharts () {
        // REGISTRATIONS
        let chartLineOptionsRegistrations = cloneDeep(this.chartLineOptions)
        chartLineOptionsRegistrations.title.text = 'Evolução de Inscrições'
        chartLineOptionsRegistrations.series.splice(0)
        chartLineOptionsRegistrations.series.push({
          name: 'Inscrições',
          data: []
        })
        chartLineOptionsRegistrations.xAxis.categories = this.registrations.map(item => item.date)
        chartLineOptionsRegistrations.series[0].data = this.registrations.map(item => item.total)
        this.chartLineOptionsRegistrations = chartLineOptionsRegistrations
        // PAPERS
        /*
        let chartLineOptionsPapers = cloneDeep(this.chartLineOptions)
        chartLineOptionsPapers.title.text = 'Evolução de Submissões'
        chartLineOptionsPapers.series.splice(0)
        let labelsY = []
        this.papers.forEach(item => {
          chartLineOptionsPapers.series.push({
            name: item.event,
            data: item.papers.map(paper => paper.total)
          })
          labelsY = [...labelsY, ...item.papers.map(paper => paper.date)]
        })
        labelsY = labelsY.sort()
        chartLineOptionsPapers.xAxis.categories = labelsY.map(item => this.dateFormat(item, 'br'))
        this.chartLineOptionsPapers = chartLineOptionsPapers
        */
      }
    }
  }
</script>

<template>
    <div>
        <ListHeader :title="event.title + ' - Eventos'" back-route="event.index"/>
        <list-empty v-if="list.length === 0" description="Nenhum evento encontrado"/>
        <el-row :gutter="20" v-if="list.length > 0">
            <el-col :span="12">
                <table class="custom-table-list">
                    <thead>
                    <tr>
                        <th>Evento</th>
                        <th>Inscrições</th>
                        <th align="center">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in list" v-bind:class="{'-no-access' : !userHaveAccess(item.coordinators)}">
                        <td>{{item.title}}</td>
                        <td>
                            <div>De: {{item.start_registration_datetime | dateTimeEnToBr}}</div>
                            <div>Até: {{item.end_registration_datetime | dateTimeEnToBr}}</div>
                        </td>
                        <td align="center">
                            <router-link :to="{name: 'event.show.home', params: {eventMainId: event.id, id: item.id}}"
                                         title="Gerenciar"
                                         class="el-button el-button--primary">
                                <span>Gerenciar</span>
                                <i class="fa fa-cog"></i>
                            </router-link>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-col>
            <el-col :span="12">
                <div v-if="chartLineOptionsRegistrations">
                    <highcharts :key="'registrations'" :options="chartLineOptionsRegistrations"/>
                </div>
                <div v-if="false">
                    <highcharts :key="'papers'" :options="chartLineOptionsPapers"/>
                </div>
            </el-col>
        </el-row>
        <div>
            <router-link :to="{name: 'event.presence', params: {id: event.id}}"
                         title="Frequência"
                         class="el-button el-button--primary">
                <span>Gerenciar Frequência</span>
                <i class="el-icon-circle-check-outline"></i>
            </router-link>
            <router-link :to="{name: 'event.report', params: {id: event.id}}"
                         v-if="!userIsOnlySupportCommittee"
                         title="Relatórios"
                         class="el-button el-button--info">
                <span>Relatórios</span>
                <i class="fa fa-file-pdf-o"></i>
            </router-link>
            <router-link :to="{name: 'event.report-admin', params: {id: event.id}}"
                         v-if="!userIsOnlySupportCommittee"
                         title="Relatórios"
                         class="el-button el-button--warning">
                <span>Relatórios Gerenciais</span>
                <i class="fa fa-file-pdf-o"></i>
            </router-link>
            <router-link :to="{name: 'event.report-finals', params: {id: event.id}}"
                         v-if="!userIsOnlySupportCommittee"
                         title="Relatórios"
                         class="el-button el-button--danger">
                <span>Relatórios Finais</span>
                <i class="fa fa-file-pdf-o"></i>
            </router-link>
            <router-link :to="{name: 'event.report-minicursos', params: {id: event.id}}"
                         v-if="!userIsOnlySupportCommittee"
                         title="Relatórios"
                         class="el-button el-button--info">
                <span>Relatórios Minicursos</span>
                <i class="fa fa-file-pdf-o"></i>
            </router-link>
        </div>
    </div>
</template>

<style lang="scss">
    .-no-access {
        opacity: .6;
        cursor: not-allowed;
        pointer-events: none;
    }
</style>



// WEBPACK FOOTER //
// ListEvents.vue?52f07e77